<template>
    <transition name="fade">
  <div
    class="contact-card-dialog-container"
    @mousewheel="mousewheel"
    v-show="dialogShow"
    @click.prevent="closeByMask($event)"
  >
    <transition name="fade">
      <div class="contact-card-dialog-wrapper" v-show="dialogShow" ref="msk">
        <div class="contact-card-dialog-header">
          <div class="close-btn" @click="close">
            <img src="@/assets/images/icon-close.png" alt="" />
          </div>
          <div class="hello-container">
            <span class="main">Hello</span>
            <span class="sub">欢迎与我们联系，获得专业的技术支持</span>
          </div>
          <div class="contact-content-container">
            <div class="contact-content-item">
              <img src="@/assets/images/icon-phone-1.png" alt="" />
              <span>{{ companyData.phone }}</span>
            </div>
            <div class="contact-content-item">
              <img src="@/assets/images/icon-location-1.png" alt="" />
              <span>{{ companyData.location }}</span>
            </div>
          </div>
        </div>
        <div class="contact-card-dialog-body">
          <div class="qr-code-container">
            <img src="" alt="" />
          </div>
          <span>扫码一对一服务</span>
        </div>
      </div>
    </transition>
  </div>
    </transition>
</template>

<script>
export default {
  data() {
    return {
      dialogShow: false,
    };
  },
  methods: {
    open() {
      this.dialogShow = true;
    },
    close() {
      this.dialogShow = false;
    },
    closeByMask(ev) {
      if (!this.$refs.msk.contains(ev.target)) {
        this.dialogShow = false;
      }
    },
    mousewheel(e) {
      e.preventDefault();
    },
  },
};
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
<style lang="scss" scoped>
.contact-card-dialog-container {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  .contact-card-dialog-wrapper {
    position: relative;
    width: 300px;
    height: 430px;
    background: #ffffff;
    .contact-card-dialog-header {
      padding: 20px 20px 0 20px;
      position: relative;
      width: 100%;
      height: 160px;
      background-image: linear-gradient(269deg, #119dfd 0%, #0764fb 100%);
      .close-btn {
        position: absolute;
        top: 8px;
        right: 8px;
        img {
          width: 14px;
          height: 14px;
          cursor: pointer;
          user-select: none;
          &:active {
            opacity: 0.8;
          }
        }
      }
      .hello-container {
        border-bottom: 1px solid #2fa7ff;
        padding-bottom: 14px;
        span {
          display: block;
        }
        .main {
          font-family: PingFangSC-Semibold;
          font-size: 24px;
          color: #ffffff;
          margin-bottom: 4px;
        }
        .sub {
          opacity: 0.7;
          font-family: PingFangSC-Regular;
          font-size: 12px;
          color: #ffffff;
        }
      }
      .contact-content-container {
        margin-top: 5px;
        .contact-content-item {
          margin-top: 9px;
          display: flex;
          align-items: center;
          img {
            width: 16px;
            height: 16px;
            margin-right: 10px;
          }
          font-family: PingFangSC-Medium;
          font-size: 12px;
          color: #ffffff;
        }
      }
    }
    .contact-card-dialog-body {
      width: 100%;
      height: 270px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .qr-code-container {
        width: 150px;
        height: 150px;
        background: #eee;
        margin-bottom: 14px;
      }
      span {
        text-align: center;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/components/contactCardDialog.vue